<template lang="pug">
  #ctn(v-cloak)
    loading(v-show='!ready && !isMobileData')
    .left-bg
    .right-bg
    transition(name='background-shape', @enter='shapeEnter', :css='false', mode='out-in', appear)
      route-background(v-show='ready', :transform='currentBackground')
    site-nav
    .wrap
      site-header(v-if='ready', ref='header', :indicator='currentIndicator')
      route-image(v-if='ready', :image='currentImage')
      .view-ctn
        transition(v-if='ready', name='page', @before-enter='beforeEnter', @enter='enter' @leave='leave', :css='false', mode='out-in', appear)
          router-view.view(ref='page')
        .clear
      .clear
    .clear
</template>

<script>
import Vue from 'vue'
import Loading from '@/components/Loading'
import siteHeader from '@/components/Header'
import siteNav from '@/components/Nav'
import routeImage from '@/components/Image'
import routeBackground from '@/components/Background'

// import anime from 'animejs'
import {TweenLite, TimelineLite, Power3} from 'gsap'
// import ScrollToPlugin from 'gsap/src/uncompressed/plugins/ScrollToPlugin'
import SplitText from '@/assets/js/SplitText.min.js'
import DrawSVGPlugin from '@/assets/js/DrawSVGPlugin'

TweenLite.defaultEase = Power3.easeOut

export default {
  name: 'app',
  components: {
    siteHeader,
    siteNav,
    routeImage,
    routeBackground,
    Loading
  },
  data () {
    return {
      ready: false,
      title: 'Donauhof Wien',
      description: 'In den Gemäuern des um 1900 errichteten »Hotel Donauhof«, das die letzten Jahrzehnte als Holzlager diente, entsteht Neues.',
      shareImg: 'http://www.donauhofwien.at/share.png',
      shareUrl: 'http://www.donauhofwien.at',
      currentIndicator: this.$refs.page ? this.$refs.page.indicator : null,
      currentImage: this.$refs.page ? this.$refs.page.image : null,
      currentHeadline: null,
      currentBackground: this.$refs.page ? this.$refs.page.background : {rotate: null, scale: {x: null, y: null}, translate: {x: null, y: null}}
    }
  },
  watch: {
    '$route' (to, from) {
      Vue.$gmapDefaultResizeBus.$emit('resize')
    }
  },
  computed: {
    isMobileData () {
      return this.isMobile()
    }
  },
  head () {
    return {
      title: '…',
      titleTemplate: '%s ~ Donauhof',
      meta: [
        { property: 'og:title', content: this.title },
        { property: 'og:description', content: this.description },
        { property: 'og:image', content: this.shareImg },
        { property: 'og:url', content: this.shareUrl },

        { property: 'twitter:site', content: '@donauhofwien' },
        { property: 'twitter:creator', content: '@maxschulmeister' },
        { property: 'twitter:title', content: this.title },
        { property: 'twitter:description', content: this.description },
        { property: 'twitter:image', content: this.shareImg },
        { property: 'twitter:card', content: 'summary_large_image' }
      ]
    }
  },
  mounted () {
    if (this.isMobileData) this.ready = true
  },
  methods: {
    shapeEnter (el, done) {
      TweenLite.from('.background-shape svg', 3, {
        // drawSVG: 0,
        scale: 0,
        rotationZ: 75,
        ease: Power3.easeOut,
        onComplete: function () {
          done()
        }
      })
    },
    enter (el, done) {
      this.currentHeadline = new SplitText(document.querySelector('h1'), {type: 'chars, words', charsClass: 'char', wordsClass: 'word'})
      this.currentIndicator = this.$refs.page.indicator
      this.currentImage = this.$refs.page.image
      this.currentBackground = this.$refs.page.background
      let tl = new TimelineLite({
        onComplete: function () {
          done()
        }
      })
      tl.staggerFromTo(this.currentHeadline.chars, 0.25, {y: 12, autoAlpha: 0}, {y: -6, autoAlpha: 1}, 0.0075, 1.5)
      tl.staggerTo(this.currentHeadline.chars, 1, {y: 0}, 0.0075, 1.75)
      tl.from('.sep svg path', 1.5, {drawSVG: 0}, '-=1')
      tl.staggerFrom('.body > *', 0.5, {y: 25, rotation: 5, autoAlpha: 0}, 0.125, '-=1.25')
    },
    leave (el, done) {
      let tl = new TimelineLite({onComplete: function () {
        done()
      }})
      tl.to(el, 0.5, {y: 25, rotation: 2, autoAlpha: 0})
    },
    beforeEnter () {
      window.scrollTo(0, 0)
      // TweenLite.to(window, 2, {scrollTo: 0})
    },
    isMobile () {
      return window.matchMedia('(max-width: 1200px)').matches
    }
  }
}
</script>

<style lang="scss">
@import "~utils";
[v-cloak] {
  display: none;
}
#ctn {
  font-family: Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif;
  margin: auto;
  position: relative;
  background: $light-blue;
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  // padding: 0 50px;

  @include desktop {
    background: transparent;
    .left-bg, .right-bg {
      width: 50%;
      height: 100%;
      position: fixed;
      top: 0;
      z-index: -10;
    }
    .left-bg {
      left: 0;
      background: $light-blue;
    }
    .right-bg {
      right: 0;
      background: $light-gold;
    }
  }

  *:not(img) {
  -webkit-backface-visibility: hidden;
  // -webkit-perspective: 1000;
  }

  .wrap {
    // @include grid-container;
    // @include grid-visual;

    // @include grid-media($tablet-grid) {
    //   @include grid-container;
    //   @include grid-visual;
    // }

    // @include grid-media($desktop-grid) {
    //   @include grid-container;
    //   @include grid-visual;
    // }
    max-width: $max-width;
    width: 100%;
    margin: auto;
    // transition: all .75s $easeInOut;
    // flex: 1 0 auto; /* 2 */
    // z-index: 2;
    > *:not(header), .indicator, .coordinates {
      transition: all .75s $easeInOut;
      transition-delay: .0625s;
    }
    .view-ctn {
      background: $light-gold;
      padding: $gutter*1 0;
      @include desktop {
        background: transparent;
        position: relative;
        width: 50%;
        vertical-align: top;
        padding: 0;
        text-align: center;
        display: inline-block;
      }
    }

    .view {
      transform-origin: top left;
      @include grid-column(6);
      @include grid-media($desktop-grid) {
        @include grid-column(8);
        margin: 0 auto;
        float: none;
        display: inline-block;
        text-align: left;
        max-width: 32rem;
      }
      // margin: $gutter*4 auto $gutter*2;
      // @include tablet {
      //   margin: $gutter*5 auto $gutter*3;
      // }
      // @include desktop {
      //   margin: $gutter*3 auto $gutter*3;
      // }      
      
      // padding: 0 map-get($desktop-grid, gutter) * 4;
      > * {
        // display: block;
        // width: calc(100% - #{map-get($desktop-grid, gutter)} * 4);
        // margin: 0 auto;
        line-height: 1.5;
      }
    }

    h1 {
      @include serif;
      font-size: 1.75rem;
      text-align: left;
      margin: 0 auto;
      display: block;
      transform: translate3d(0,0,0);
      -webkit-backface-visibility: hidden;
      -webkit-perspective: 1000;
    }

    h2, h3 {
      @include sans;
      text-transform: uppercase;
      letter-spacing: .2em;
      font-size: .875rem;
      font-weight: bold;
      color: $gold;
    }

    h3 {
      font-size: .75rem;
    }

    .gold {
      color: $gold;
    }

    .body {
      > * {
        transform-origin: top left;
      }
      p {
        @include serif;
        font-size: 1rem;
        line-height: 1.75;
        text-align: left;
        margin-bottom: 1.75rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .cta {
      @include sans;
      font-size: .875rem;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      font-weight: bold;
      color: $gold;
      outline: 2px solid $gold;
      outline-offset: -2px;
      padding: .75rem 1rem;
      position: relative;
      background: $light-gold;
      display: inline-block;
      width: auto;
      height: auto;
      // appearance: none;
      border: none;
      transition: all .25s $easeOut;
      // backface-visibility: initial;
      // transform-style: preserve-3d;
      // transform: translate3d(0,0,0);
      &:before, &:after {
        @include pseudo;
        background: $gold;
        display: block;
        transform-origin: center top;
        transition: all .25s $easeOut;
      }
      $shadow-width: 2px;
      $shadow-offset: 0;
      &:before {
        bottom: $shadow-offset * -1;
        left: $shadow-offset;
        top: auto;
        height: $shadow-width;
        // width: calc(100% + #{$shadow-width / 2});
        transform: scale3d(1,1,1);
        transform-origin: center top;
      }
      &:after {
        width: $shadow-width;
        // height: calc(100% + #{$shadow-width / 2});
        right: $shadow-offset * -1;
        top: $shadow-offset;
        left: auto;
        transform: scale3d(1,1,1);
        transform-origin: left center;
      }
      &:hover:before{
        transform: translate3d($shadow-width, $shadow-width, 0);
        transition: transform .25s $easeOut;
        // transition-delay: .125s;
      },
      &:hover:after {
        transform: translate3d($shadow-width, $shadow-width, 0);
        transition: transform .25s $easeOut;
        // transition-delay: .125s;
        }
    }
  }
}

// page transition
// .page-enter, .page-leave-to {
//   opacity: 0;
//   transform: translate3d(0, 50px, 0)
// }

// .page-enter-to, .page-leave {
//   opacity: 1;
//   transform: translate3d(0, 0, 0)
// }

// .page-enter-active, .page-leave-active {
//   transition: all .5s $easeOut;
// }

footer {
  transition: opacity .5s $easeOut;
}
</style>



// WEBPACK FOOTER //
// App.vue?d1770cf0